// ══════════════════════════════════════════════════════
//  html/valuationHtml.js — 估值倍数 PDF 模板（buildReportHtml 调用）
//
//  纯字符串模板，不依赖 React。返回 '' 表示该 section 应隐藏。
// ══════════════════════════════════════════════════════

import { extract } from '../extractors/valuation';
import { fmtUSD, fmtRatio } from '../extractors/_shared';
import { judgeMcRev, judgeFdvRev } from '../judgments/valuationRatios';

const txt = (lang, zh, en) => (lang === 'en' ? en : zh);

export function buildHtml(project, a, lang = 'zh') {
  const d = extract(project, a);
  if (!d) return '';

  const ratioRow = (name, val, judg, accent = false) => `
    <tr style="border-bottom:1px solid #f3f4f6">
      <td style="padding:7px 10px;color:#374151">${name}</td>
      <td style="padding:7px 10px;text-align:right;font-weight:700;color:${accent ? '#2563eb' : '#111827'}">${val}</td>
      <td style="padding:7px 10px;text-align:right;font-size:11px;color:#6b7280">
        ${judg ? `${judg.emoji} ${txt(lang, judg.labelZh, judg.labelEn)}` : '—'}
      </td>
    </tr>`;

  const rows = [];
  if (d.mcFees != null)  rows.push(ratioRow('MC / Fees (Ann.)',     fmtRatio(d.mcFees),  null));
  if (d.mcRev != null)   rows.push(ratioRow('MC / Revenue (Ann.)',  fmtRatio(d.mcRev),   judgeMcRev(d.mcRev), true));
  if (d.fdvFees != null) rows.push(ratioRow('FDMC / Fees (Ann.)',   fmtRatio(d.fdvFees), null));
  if (d.fdvRev != null)  rows.push(ratioRow('FDMC / Revenue (Ann.)', fmtRatio(d.fdvRev), judgeFdvRev(d.fdvRev), true));

  return `
<div style="border:1px solid #e5e7eb;border-radius:10px;overflow:hidden;margin-bottom:14px">
  <div style="padding:13px 16px;background:#fafafa;border-bottom:1px solid #f3f4f6;font-size:13px;font-weight:800;color:#111827">
    💰 ${txt(lang, '估值 & 核心倍数', 'Valuation & Key Multiples')}
    <span style="margin-left:8px;font-weight:400;font-size:10px;color:#94a3b8">${d.source}</span>
  </div>
  <div style="padding:14px 16px">
    <div style="display:flex;gap:14px;margin-bottom:12px">
      ${d.feesAnn != null ? `
        <div style="flex:1">
          <div style="font-size:10px;color:#6b7280">${txt(lang, '30日手续费（年化）', '30d Fees (Annualized)')}</div>
          <div style="font-size:16px;font-weight:800;color:#111827">${fmtUSD(d.feesAnn)}</div>
        </div>` : ''}
      ${d.revAnn != null ? `
        <div style="flex:1">
          <div style="font-size:10px;color:#6b7280">${txt(lang, '30日收入（年化）', '30d Revenue (Annualized)')}</div>
          <div style="font-size:16px;font-weight:800;color:#111827">${fmtUSD(d.revAnn)}</div>
        </div>` : ''}
    </div>
    ${rows.length > 0 ? `
      <table style="width:100%;font-size:11px;border-collapse:collapse">
        <thead><tr style="background:#f9fafb">
          <th style="padding:6px 10px;text-align:left;color:#6b7280;font-size:10px">${txt(lang, '估值倍数', 'Ratio')}</th>
          <th style="padding:6px 10px;text-align:right;color:#6b7280;font-size:10px">${txt(lang, '当前值', 'Value')}</th>
          <th style="padding:6px 10px;text-align:right;color:#6b7280;font-size:10px">${txt(lang, '判断', 'Judgment')}</th>
        </tr></thead>
        <tbody>${rows.join('')}</tbody>
      </table>` : ''}
  </div>
</div>`;
}
